import React from "react";
import "./styles.css";

export const Input = React.forwardRef((props, ref) => {
  return (
    <input
      ref={ref}
      className="custom-signal-com-required-input mb-2"
      {...props}
    />
  );
});